// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1M7C7","header":"MergedInvoice_header__nPMx2"};